export class Constant {
  public static email = '';
  //public static email='sales@mehman.pk';

  public static phone = '0325-4888818';
}
